import { Burger } from "@mantine/core";

interface HeaderLayoutProps {
  opened: boolean;
  setOpened: (opened: boolean) => void;
}

export default function BurgerModule({ opened, setOpened }: HeaderLayoutProps) {
  return (
    // <MediaQuery largerThan="sm" styles={{ display: "none" }}>
    <Burger
      title={`${opened ? "Close" : "Open"} navigation`}
      opened={opened}
      onClick={(e) => {
        e.stopPropagation();
        setOpened(!opened);
      }}
      size={20}
      color={"lightblue"}
      style={{
        justifySelf: "start",
      }}
    />
    // </MediaQuery>
  );
}
